export const DATE_FORMAT_M_D_YY = 'M-D-YY';
export const DATE_FORMAT_MM = 'MM';
export const DATE_FORMAT_MMMM = 'MMMM';
export const DATE_FORMAT_DEFAULT = 'YYYY-MM-DD';
